import { FC } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import SvgDocument from '@public/assets/pages/interwill/document.svg';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';

import { ButtonBlue } from '../../ButtonBlue';

import { StepBodyContainer } from './StepBody';
import { StepBodyProps } from './types';

export const StepBodyIntroduction: FC<StepBodyProps> = ({ onAction }) => {
  const { t } = useTranslation('pages/pageInterwill', { keyPrefix: 'progress.introduction' });

  return (
    <Container showBorder={true}>
      <ImageMobile src={SvgDocument} width={44} height={58} alt="doc" />
      <Message>{t('message')}</Message>
      <ButtonBlue onClick={onAction}>{t('btnBegin')}</ButtonBlue>
    </Container>
  );
};

const Container = styled(StepBodyContainer)`
  flex: 1;
  align-items: center;
  justify-content: center;
  border: 3px dashed ${COLORS.systemSky100};
  border-radius: 12px;

  ${media.iwMobile} {
    min-height: 324px;
    justify-content: center;
  }
`;

const ImageMobile = styled(Image)`
  // @media screen and (min-width: 992px) {
  ${media.iwNotMobile} {
    display: none;
  }
`;

const Message = styled.span`
  font-weight: 700;
  font-size: 18px;
  text-align: center;
`;
